import { Collapse }  from "@mantine/core";
import { useRouter } from "next/router";

import { useGetDeviceType } from "_common/hooks/global";
import { isPageRoute }      from "_common/utils";
import BackgroundWrapper    from "_components/atoms/backgroundWrapper";
import Icon                 from "_components/atoms/icon";
import InputFieldVideos     from "_components/atoms/inputFieldVideos";
import MobileBottomDrawer   from "_components/atoms/mobileBottomDrawer";
import Typography           from "_components/atoms/typography";
import EmojiModal           from "_components/features/chat/userInteractions/emojiModal";
import { shortenNumber }    from "_components/features/player/utils";
import ItemList             from "_components/organisms/reactionBox/ItemList";

import useStyles from "./styles";

const component = ( {
	toggleCollapse,
	collapse,
	commentCount,
	displayEmoji,
	handleEmojiSelect,
	commentInput,
	focusState,
	handleOnCommentChange,
	handleSendClick,
	handleToggleEmoji,
	throttledCommentToPost,
	textInput,
	toggleFocusState,
	currentTabParams,
	emotesList,
	fetchComments,
	openCommentModal,
	setOpenCommentModal,
	onClose
} ) => {

	const router      = useRouter ();
	const isVideoPage = isPageRoute ( { router, page: "video" } );

	const { classes } = useStyles ( { displayEmoji, collapse, isVideoPage } );

	const deviceType       = useGetDeviceType ();
	const isMobileOrTablet = deviceType === "mobile" || deviceType === "tablet";

	const commentsList = (
		<ItemList
			activeTab = { 0 }
			dataList = { currentTabParams.data }
			emotesList = { emotesList }
			fetchComments = { fetchComments }
			isDepleted = { currentTabParams.isDepleted }
			isFetching = { currentTabParams.isFetching }
			pageNo = { currentTabParams.pageNo }
		/>
	);

	const inputBox = (
		<>
			<BackgroundWrapper className = { classes.emojiModalParent }
				type = "secondary"
			>
				{
					displayEmoji ? (
						<div className = { classes.emojiModalWrapper }>
							<EmojiModal handleEmojiSelect = { handleEmojiSelect } />
						</div>
					) : null
				}
			</BackgroundWrapper>

			<div className = { classes.inputComment }>
				<InputFieldVideos
					commentInput = { commentInput }
					displayEmoji = { displayEmoji }
					focusState = { focusState }
					from = "videos"
					handleEmojiSelect = { handleEmojiSelect }
					handleOnChange = { handleOnCommentChange }
					handleSendClick = { handleSendClick }
					handleToggleEmoji = { handleToggleEmoji }
					textInput = { textInput }
					throttledCommentToPost = { throttledCommentToPost }
					toggleFocusState = { toggleFocusState }
				/>
			</div>

		</>
	);

	const mobileCommentsDrawer = (
		<MobileBottomDrawer
			noBorderRadius
			noOverlay
			closeOnClickOutside = { false }
			isOpen = { openCommentModal }
			onClose = { () => {
				setOpenCommentModal ( false );
				onClose ();
			} }
		>
			<div className = { classes.mobileCommentsContainer }>
				<div className = { classes.mobileHeader }>
					<Typography
						className = { classes.headerTitle }
						title = { `Comments (${ shortenNumber ( commentCount ) })` }
					/>

					<Icon
						className = { classes.closeIcon }
						name = "cross"
						onClick = { () => {
							setOpenCommentModal ( false );
							onClose ();
						} }
					/>
				</div>

				<div className = { classes.mobileCommentsList }>
					{commentsList}
				</div>

			</div>

			<div className = { classes.mobileInputContainet }>
				{inputBox}
			</div>
		</MobileBottomDrawer>
	);

	if ( isMobileOrTablet ) {
		return mobileCommentsDrawer;
	}

	return (
		<div className = { classes.videoChatContainer }>
			<BackgroundWrapper
				className = { classes.videosChatHeader }
				onClick = { () => toggleCollapse ( { openOnly: false } ) }
			>
				<Typography
					className = { classes.commentCount }
					title = { `Comments (${ shortenNumber ( commentCount ) })` }
				/>

				<Icon
					className = { classes.arrowIcon }
					name = { collapse ? "arrowUpIcon" : "arrowDownIcon" }
				/>

			</BackgroundWrapper>

			<Collapse in = { collapse }>
				<div className = { classes.itemList }>
					{commentsList}
				</div>

				<BackgroundWrapper className = { classes.emojiModalParent }
					type = "secondary"
				>
					{
						displayEmoji ? (
							<div className = { classes.emojiModalWrapper }>
								<EmojiModal handleEmojiSelect = { handleEmojiSelect } />
							</div>
						) : null
					}
				</BackgroundWrapper>

				<div className = { classes.inputComment }>
					<InputFieldVideos
						commentInput = { commentInput }
						displayEmoji = { displayEmoji }
						focusState = { focusState }
						from = "videos"
						handleEmojiSelect = { handleEmojiSelect }
						handleOnChange = { handleOnCommentChange }
						handleSendClick = { handleSendClick }
						handleToggleEmoji = { handleToggleEmoji }
						textInput = { textInput }
						throttledCommentToPost = { throttledCommentToPost }
						toggleFocusState = { toggleFocusState }

					/>
				</div>

			</Collapse>

		</div>
	);
};

export default component;
